import React, {ReactElement} from "react";
import {Dialog} from "@headlessui/react";
import {FormattedMessage} from "react-intl";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {ImageUploader, ImageUploaderProps} from "components/UIComponents/imageupload/ImageUploader";

export interface ImagePickerUploadModalProps {
    open: boolean
    onClose: () => void
    upload: ImageUploaderProps
}

export function ImagePickerUploadModal(props: ImagePickerUploadModalProps): ReactElement {

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            className="fixed z-modal inset-0 overflow-y-auto"
        >
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay className="fixed inset-0 bg-text opacity-60"/>

                <div className="relative flex flex-col w-2/3 max-w-lg h-2/3 mx-auto gap-5
                                py-4 px-5 bg-white rounded-lg">
                    <div className="flex-none flex items-center">
                        <Dialog.Title className="flex-auto font-barlow text-lg font-semibold">
                            <FormattedMessage id="editor.image.upload"/>
                        </Dialog.Title>
                        <button className="flex-none"
                                onClick={props.onClose}>
                            <CloseIcon className="inline-block w-5 h-5"/>
                        </button>
                    </div>

                    <ImageUploader {...props.upload} />
                </div>
            </div>
        </Dialog>
    );
}